module.exports = __webpack_public_path__ + "static/media/2.99974e17.png";